import React, { useEffect, useState } from "react";
import { Application } from "@/api/applications";
import {
  Customer,
  ApplicationCustomerUsers,
  addApplicationCustomerUsers,
} from "@/api/customers";
import { User, UserModel, addUser } from "@/api/users";
import RigthPanel from "@/ui-controls/RigthPanel";
import NewUserForm from "@/components/users/NewUserForm";

interface Props {
  application: Application | undefined;
  customer: Customer | undefined;
  allUsers: User[];
  nonCustomerUsers: User[];
  isPanelOpenned: boolean;
  onSaveNewUser?: (user: User) => any;
  onSave?: (appCustomerUsers: ApplicationCustomerUsers) => any;
  onPanelClosed?: () => any;
}

const NewAppCustomerUserPanel = (props: Props) => {
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  useEffect(() => {
    setIPanelOpen(props.isPanelOpenned);
  }, [props.isPanelOpenned]);

  const onClosePanel = () => {
    setIPanelOpen(false);
    if (props.onPanelClosed) props.onPanelClosed();
  };

  const assignUsers = (users: User[]) => {
    if (!props.application || !props.customer) return;
    setIsSaving(true);
    const appCustomerUsers: ApplicationCustomerUsers = {
      AppId: props.application.Id,
      CustomerId: props.customer.Id,
      UserIds: users.map((u) => u.Id),
    };

    addApplicationCustomerUsers(appCustomerUsers).then(
      (_) => {
        setIsSaving(false);
        if (props.onSave) props.onSave(appCustomerUsers);
      },
      (error) => {
        setIsSaving(false);
        handleError(error);
      }
    );
  };

  const addNewUser = (usermodel: UserModel) => {
    setIsSaving(true);
    addUser(usermodel).then(
      (result) => {
        const createdUser = { ...result, RolesCount: 0 };
        if (props.onSaveNewUser) props.onSaveNewUser(createdUser);
        setIsSaving(false);
      },
      (error) => {
        handleError(error);
        setIsSaving(false);
      }
    );
  };

  const handleError = (error: any) => {
    // Error handled by parent component
  };

  return (
    <>
      <RigthPanel
        header="Add New Customer User"
        isOpen={isPanelOpen}
        dismissPanel={onClosePanel}
        childComponent={NewUserForm}
        childProps={{
          allUsers: props.allUsers,
          nonAssignedUsers: props.nonCustomerUsers,
          isSaving: isSaving,
          onClose: () => onClosePanel(),
          onAddNewUser: addNewUser,
          onAssignUsers: assignUsers,
        }}
      ></RigthPanel>
    </>
  );
};

export default NewAppCustomerUserPanel;
